export const TEST_IDS = {
  CONTAINER: 'header',
  LOGO_LINK: 'header-logo-link',
  AUTH_SLOT: 'header-auth-slot',
  AUTH_SECTION: 'header-auth-section',
  AUTH_SKELETON: 'header-auth-skeleton',
  AUTH_SKELETON_PRICING: 'header-auth-skeleton-pricing',
  AUTH_SKELETON_PROJECTS: 'header-auth-skeleton-projects',
  AUTH_SKELETON_AVATAR: 'header-auth-skeleton-avatar',
  PRICING_BUTTON: 'header-pricing-button',
  PRICING_BADGE: 'header-pricing-badge',
  SIGN_IN_BUTTON: 'header-sign-in-button',
  PROJECTS_BUTTON: 'header-projects-button',
  USER_AVATAR: 'header-user-avatar',
  USER_MENU: 'header-user-menu',
  CREDITS_BADGE: 'header-credits-badge',
  CREDITS_ROW: 'header-credits-row',
  GO_PREMIUM_ROW: 'header-go-premium-row',
  UPGRADE_BUTTON: 'header-upgrade-button',
  SIGN_OUT_BUTTON: 'header-sign-out-button',
} as const;
